import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { gispertSection3 } from '../utils/gispertContent3';
import { gispertSection3En } from '../utils/gispertContent3En';
import { getRelatedSectionsForGispert } from '../utils/relatedSections';
import RelatedSections from './RelatedSections';
import ContentGate from './ContentGate';

const Gispert3 = () => {
  const { t, i18n } = useTranslation();
  const content = i18n.language === 'en' ? gispertSection3En : gispertSection3;
  const [isUnlocked, setIsUnlocked] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('spain_project_unlocked') === 'true') {
      setIsUnlocked(true);
    }
  }, []);


  return (
    <div className='TesisPage TesisPage--gispert'>
      <aside className='TesisPage-rail'>
        <RelatedSections items={getRelatedSectionsForGispert('/Gispert3')} />
      </aside>
      <h1 className='TesisPageTitle'>{t('gispert3.title')}</h1>
      <h2 className='TesisPageSubtitle'>{t('gispert3.subtitle')}</h2>
      <article className='TesisPageContent'>
        {isUnlocked ? (
          <>
            {content.map((p, i) => <p key={i}>{p}</p>)}
          </>
        ) : (
          <ContentGate onUnlocked={() => setIsUnlocked(true)} />
        )}
      </article>
    </div>
  );
};

export default Gispert3;
